import { ROLE, STAFF_LIST } from '../../consts/user';

export function getCreatableStaffRoles(school: any): string[] {
  return school?.kind === 'School' ? STAFF_LIST.filter(role => isSchoolRoleEnabled(school, role)) : [];
}

// Keep legacy defaults aligned with SchoolLike and the backend schoolRolePolicy.
export function isSchoolRoleEnabled(school: any, role: string): boolean {
  if (!school) return false;
  const value = (school?.allowedPermissionPresets || {})[role];
  return role === ROLE.TOURNAMENT_FOLLOWER ? value === true : value !== false;
}

export const REQUESTABLE_SCHOOL_ROLES = [ROLE.ADMIN, ROLE.MANAGER, ROLE.TEACHER, ROLE.COACH, ROLE.SLT, ROLE.PARENT, ROLE.STUDENT];

export function canRequestSchoolRole(school: any, role: string): boolean {
  if (!school || school._isRemoved || school.availableForRegistration === false || !isSchoolRoleEnabled(school, role)) return false;
  if (school.kind === 'SchoolUnion') return role === ROLE.ADMIN || role === ROLE.TOURNAMENT_FOLLOWER;
  if (!REQUESTABLE_SCHOOL_ROLES.includes(role)) return false;
  return role !== ROLE.STUDENT || school.studentSelfRegistrationEnabled === true;
}

export function schoolRoleRequestFilters(roles: string[]): any[] {
  return roles.map(role => ({
    kind: role === ROLE.TOURNAMENT_FOLLOWER ? 'SchoolUnion' : role === ROLE.ADMIN ? {$in: ['School', 'SchoolUnion']} : 'School',
    [`allowedPermissionPresets.${role}`]: role === ROLE.TOURNAMENT_FOLLOWER ? true : {$ne: false},
    ...(role === ROLE.STUDENT ? {studentSelfRegistrationEnabled: true} : {})
  }));
}
